<template>
    <div class="afterSales">
        <div class="afterSales-banner"></div>
        <div class="afterSales-content afterSales-content-white">
            <div class="main_content">
                <div class="afterSales-content-title">安装视频</div>
                <div class="video-list">
                    <div class="video-item" v-for="(video,index) in installList" :key="video.url + index"
                         @click="openVideoDetail(video)">
                        <div class="video-item-img">
                            <img :src="video.img" alt="video">
                        </div>
                        <div class="video-title">{{ video.title }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="afterSales-content afterSales-content-gray">
            <div class="main_content">
                <div class="afterSales-content-title">展示视频</div>
                <div class="video-list">
                    <div class="video-item" v-for="(video,index) in showList" :key="video.url + index"
                         @click="openVideoDetail(video)">
                        <div class="video-item-img">
                            <img :src="video.img" alt="video">
                        </div>
                        <div class="video-title">{{ video.title }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="max-container" v-show="showDialog">
            <div class="close-icon" @click="closeVideoDetail"></div>
            <video :src="videoSrc" controls autoplay></video>
        </div>
    </div>
</template>

<script>
export default {
    name: "Videos",
    data() {
        return {
            installList: [
                {
                    title: "KM-202MD",
                    text: "打印机安装视频，适用KM-202MD打印",
                    img: require("@/views/afterSalesService/videos/images/video.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspaz/KM202MD/KM202MD安装.mp4"
                },
                {
                    title: "KM-106M",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/RX106M-1.264.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspaz/KM106M/KM106M安装.mp4"
                },
                {
                    title: "KM360A",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/KM-360AN.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspaz/KM360A/KM360A安装.mp4"
                },
                {
                    title: "KM-167",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/video.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspaz/KM167/km167安装.mp4"
                },
                {
                    title: "KM-118BT",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/118BT.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspaz/KM118BT/KM-118BT安装.mp4"
                },
                {
                    title: "KM-202BT",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/KM202BT.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspaz/KM202BT/KM-202bT安装.mp4"
                },
                {
                    title: "KM-106",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/106.337.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspaz/KM106/KM106安装.mp4"
                },
                {
                    title: "KM-218",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/218.237.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspaz/KM218/KM218安装.mp4"
                },
                {
                    title: "CI250",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/CI250.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspaz/CI250/CI250安装.mp4"
                },
                {
                    title: "KM600",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/KM600.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspaz/KM600/KM-600安装.mp4"
                },
                {
                    title: "KM300",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/KM300.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspaz/KM300/KM300安装.mp4"
                },
            ],
            showList: [
                {
                    title: "KM-118M",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/118M.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/KM18M/118M展示.mp4"
                },
                {
                    title: "KM-118D",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/video.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/KM18D/KM118D展示.mp4"
                },
                {
                    title: "KM-202MD",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/202MD.750.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/KM202MD1/KM202MD展示1.mp4"
                },
                {
                    title: "KM-202MD",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/202MD.750.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/KM202MD2KM202MD展示2.mp4"
                },
                {
                    title: "KM360A",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/KM-360AN.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/KM360A/KM360A展示.mp4"
                },
                {
                    title: "DP358",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/DP358.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/DP358/DP358展示.mp4"
                },
                {
                    title: "KM-106M",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/106.337.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/KM06M/KM106M展示.mp4"
                },
                {
                    title: "KM-167",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/KM-167.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/KM167/KM167展示.mp4"
                },
                {
                    title: "UL410",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/UL410-4.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/UL410/UL410展示.mp4"
                },
                {
                    title: "RL210",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/RL210.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/RL210/RL210展示.mp4"
                },
                {
                    title: "RL210BT",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/RL210BT.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/RL210BT/RL210BT展示.mp4"
                },
                {
                    title: "LP380",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/LP380.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/LP380/LP380.mp4"
                },
                {
                    title: "SL410",
                    text: "打印机安装视频",
                    img: require("@/views/afterSalesService/videos/images/SL410BT.853.png"),
                    url: "https://kuaimai-public.oss-cn-shanghai.aliyuncs.com/public/gwspzs/SL410/SL40展示.mp4"
                },
            ],
            showDialog: false,
            videoSrc: ""
        };
    },
    mounted() {
    },
    methods: {
        openVideoDetail(video) {
            this.showDialog = true;
            this.videoSrc = video.url;
        },
        closeVideoDetail() {
            this.showDialog = false
            this.videoSrc = "";
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../afterSales.scss";

.video-list {
    margin-top: 24rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 38rem;
    row-gap: 32rem;

    .video-item {
        width: 272rem;
        height: 246rem;
        background: #FFFFFF;
        border-radius: 20rem;
        border: 1px solid #DBDBDB;
        overflow: hidden;
        cursor: pointer;

        &:hover {
            .video-item-img img {
                transform: scale(1.1);
            }
        }

        .video-item-img {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 272rem;
            height: 200rem;
            overflow: hidden;
            background: rgba(221, 221, 221, 1);

            img {
                max-width: 100%;
                max-height: 100%;
            }
        }

        .video-title {
            padding: 0 20rem;
            margin-top: 11rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 20rem;
            color: #333333;
            line-height: 28rem;
        }

        .video-text {
            padding: 0 20rem;
            margin-top: 4rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12rem;
            color: #666666;
            line-height: 17rem;
        }
    }
}

.max-container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgb(66, 66, 66);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;

    video {
        width: 80%;
        height: 80%;
    }

    .close-icon {
        position: absolute;
        top: 40rem;
        right: 40rem;
        width: 50rem;
        height: 50rem;
        background: rgb(0, 0, 0);
        border-radius: 50%;
        cursor: pointer;

        &::before, &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate3d(-50%, -50%, 0) rotate(45deg);
            width: 30rem;
            height: 1rem;
            background: #fff;
        }

        &::after {
            transform: translate3d(-50%, -50%, 0) rotate(-45deg);
        }
    }
}
</style>
